import { getPlans, Plan } from '@otter-ai/recall-client';
import { HOUR_MS } from '#constants';
import { QueryOptions, QueryResult } from './types';

type PlansQueryKey = ['plans'];

const staleTime = 2 * HOUR_MS; // Data stays fresh for 2 hours

/**
 * Create a query to fetch details about subscription plans
 *
 * @example
 * ```tsx
 * * const { data: plans } = useQuery(plansQueryCreator(123));
 * ```
 */

export function plansQueryCreator(
  additionalOptions: QueryOptions<Plan[], PlansQueryKey> = {},
): QueryResult<Plan[], PlansQueryKey> {
  return {
    ...additionalOptions,
    staleTime,
    queryKey: ['plans'],
    queryFn: async () => {
      const response = await getPlans();
      if (response.error) {
        throw response.data;
      }
      return response.data.plans;
    },
  };
}
